import React, { useEffect, useState } from 'react'
import Axios from 'axios';
import { types } from '../LandingPage/Sections/Datas'
import { PORT_SERVER } from '../../../Config';
import { staticPathForBuildModeWithURL } from '../../utils/ImageSlider';

function MyProductPage(props) {
    {

        const [Products, setProducts] = useState([])
        const [Skip, setSkip] = useState(0)
        const [Limit, setLimit] = useState(10)
        const [PostSize, setPostSize] = useState()

        useEffect(() => {

            if (!props.user.userData) {
                console.log('userData 를 확인할수 없습니다')
                return;
            }

            const variables = {
                skip: Skip,
                limit: Limit,
                writer: props.user.userData._id
            }

            getProducts(variables)

        }, [props.user])

        const getProducts = (variables) => {
            Axios.post('/api/product/getProducts', variables)
                .then(response => {
                    if (response.data.success) {
                        if (variables.loadMore) {
                            setProducts([...Products, ...response.data.products])
                        } else {
                            setProducts(response.data.products)
                        }
                        setPostSize(response.data.postSize)
                    } else {
                        console.log('Failed to fectch product datas')
                    }
                })
        }

        const onLoadMore = () => {
            let skip = Skip + Limit;

            const variables = {
                skip: skip,
                limit: Limit,
                loadMore: true,
                writer: props.user.userData._id
            }
            getProducts(variables)
            setSkip(skip)
        }


        const renderCartImage = (images) => {
            if (images.length > 0) {
                let image = images[0]
                return staticPathForBuildModeWithURL(image)
            }
        }


        return (
            <div className='page'>

                {Products.length === 0 ?
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <h2>등록된 항목이 없습니다</h2>
                    </div> :
                    <div>

                        <table>
                            <thead>
                                <tr>
                                    <th>이미지</th>
                                    <th>제목</th>
                                    <th>설명</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Products.map(prd => (
                                    <tr key={prd._id} onClick={()=>{props.history.push(`/product/${prd._id}`)}}>
                                        <td>
                                            <img style={{ width: '100%' }} alt="product"
                                                src={renderCartImage(prd.images)} />
                                        </td>
                                        <td>{prd.title}</td>
                                        <td>{prd.description}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>
                }
                <br /><br />

                {PostSize >= Limit &&
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <button onClick={onLoadMore}>Load More</button>
                    </div>
                }

            </div>
        )
    }
}

export default MyProductPage
